import React from 'react';
import type { FloorCard } from '../services/floorStateService';

const SEVERITY_STYLE: Record<FloorCard['severity'], { bg: string; text: string; border: string }> = {
  danger:  { bg: '#FEF2F2', text: '#b91c1c', border: '#FECACA' },
  amber:   { bg: '#FFFBEB', text: '#92400E', border: '#FCD34D' },
  purple:  { bg: '#EDE9FE', text: '#6d28d9', border: '#C4B5FD' },
  neutral: { bg: '#F3F4F6', text: '#6B7280', border: '#E5E7EB' },
};

interface Props {
  card: FloorCard;
  onAction?: (card: FloorCard) => void;
  compact?: boolean;
}

export function FloorStateCard({ card, onAction, compact }: Props) {
  const style = SEVERITY_STYLE[card.severity] || SEVERITY_STYLE.neutral;

  return (
    <div className="w-full text-left p-3 rounded-xl border border-trim">
      <div className="flex items-start gap-2.5">
        <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: style.bg }}>
          <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
            <path d="M3 3.5h8M3 6.5h6M3 9.5h8" stroke={style.text} strokeWidth="1.3" strokeLinecap="round" />
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="text-sm font-semibold text-ink leading-tight">{card.fact}</span>
            {card.mocked && (
              <span
                className="px-1.5 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap"
                style={{ background: '#FFFBEB', color: '#92400E', border: '1px solid #FCD34D' }}
                title="Placeholder — not yet tracked from real data"
              >
                Sample data
              </span>
            )}
          </div>
          <div className="text-xs text-muted mt-0.5">{card.recommendation}</div>
        </div>
        {!compact && onAction && (
          <button
            onClick={() => onAction(card)}
            className="px-2.5 py-1 rounded-full text-xs font-semibold transition-colors hover:opacity-80 flex-shrink-0"
            style={{ background: style.bg, color: style.text, border: `1px solid ${style.border}` }}
          >
            {card.action.label}
          </button>
        )}
      </div>
    </div>
  );
}
